export const isLoggedIn = (store) =>
    !!store.user.authentication.accessToken;

